import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, FullBar } from "cakemail-ui-components/lib/react";
import { Translate, I18n } from "react-redux-i18n";
import PropTypes from "prop-types";
import BrandElement from "assets/js/scenes/brand/components/brandElements/BrandElement";
import BrandLink from "assets/js/scenes/brand/components/brandElements/BrandLink";
import { isPartner } from "utils/apiUtils";
import BrandString from "assets/js/scenes/brand/components/brandElements/BrandString";
import { getCurrentBrandFromState } from "assets/js/scenes/brand/utils";

const basePath = "client_config";
let key = new Date().getTime();
export const Settings = (props) => {
	const base = props.localBrand?.client_config;
	const defaultBase = props.brand?.client_config;

	return (
		<div className="brandModalTabContent Colours" key={key}>
			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tab-settings-section-title" />
					</p>
				}
			/>

			{isPartner() ? (
				<div className="brandElementsContainer">
					<BrandElement
						path={basePath + ".support.email"}
						title={<Translate value="app-brand-settings-support-email-title" />}
						desc={<Translate value="app-brand-settings-support-email-desc" />}
						rightPanel={
							<BrandLink
								path={basePath + ".support.email"}
								link={base?.["support"]?.["email"]}
								defaultLink={defaultBase?.["support"]?.["email"]}
								type="email"
								useDefaultOption
								defaultMessage={I18n.t(
									"app-brand-settings-support-email-default-message"
								)}
							/>
						}
					/>
				</div>
			) : (
				<div className="brandElementsContainer">
					<BrandElement
						path={basePath + ".brand_repo.url"}
						title={
							<Translate value="app-brand-settings-brand-repo-url-title" />
						}
						desc={<Translate value="app-brand-settings-brand-repo-url-desc" />}
						rightPanel={
							<BrandString
								path={basePath + ".brand_repo.url"}
								string={base?.["brand_repo"]?.["url"]}
								defaultString={defaultBase?.["brand_repo"]?.["url"]}
								type="url"
								fieldName="brandRepo"
								fieldPlaceholder={I18n.t(
									"app-brand-setting-brand-repo-url-placeholder"
								)}
							/>
						}
					/>
				</div>
			)}
		</div>
	);
};

Settings.propTypes = {
	localBrand: PropTypes.object,
	brand: PropTypes.object,
	resetTabData: PropTypes.func,
	resellerName: PropTypes.string,
};

Settings.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {
				localBrand: state.localBrand.data,
				brand: getCurrentBrandFromState(state),
				resellerName: state.brand?.name,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(Settings)
);
